export const STORAGE_KEYS = {
  EXHIBITS_SITE_ID: 'exhibits.site-id',
  FACILITIES_SITE_ID: 'facilities.site-id',
  EVENTS_SITE_ID: 'events.site-id',
  EVENTS_TYPE_ID: 'events.type-id',
  EVENTS_CALENDAR_VIEW: 'events.calendar-view',
  INTERACTION_AREAS_SITE_ID: 'interaction-areas.site-id',

} as const;

type StorageKeys = typeof STORAGE_KEYS;
type StorageKey = StorageKeys[keyof StorageKeys];

// Get stored item from local storage
export function getStoredItem(key: StorageKey) {
  if (!localStorage) return null;

  return localStorage.getItem(key);
}

// Set an item in local storage
export function setStoredItem(key: StorageKey, value: string) {
  if (!localStorage) return;

  localStorage.setItem(key, value);
}